import { createStore, applyMiddleware } from "redux"
import logger from "redux-logger"
import reducers from './union'

// Инициализация хранилища
export default () => {
    const store = window.location.protocol === 'http:' ? createStore(reducers, applyMiddleware(logger)) : createStore(reducers, applyMiddleware());
    return store
}
